(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const appendClones = (targets, items) => {
      targets.forEach((target) => {
        target.replaceChildren();
        items.forEach((item) => {
          target.appendChild(item.cloneNode(true));
        });
      });
    };

    const buildSection = (sectionElement) => {
      const collectTargets = (prefix, rows) => {
        return Array.from({ length: rows }, (_, index) =>
          sectionElement.querySelectorAll(`[data-ugc-target="${prefix}-${index + 1}"]`)
        );
      };

      const distributeItems = (items, rowCount) => {
        const rows = [];
        const itemCount = items.length;
        const baseSize = Math.floor(itemCount / rowCount);
        const remainder = itemCount % rowCount;
        let startIndex = 0;

        for (let index = 0; index < rowCount; index += 1) {
          const rowSize = baseSize + (index < remainder ? 1 : 0);
          rows.push(items.slice(startIndex, startIndex + rowSize));
          startIndex += rowSize;
        }

        return rows.map((rowItems) => (rowItems.length ? rowItems : items));
      };

      const source = sectionElement.querySelector('[data-ugc-source]');
      if (!(source instanceof HTMLElement)) return;

      const sourceItems = Array.from(source.children);
      const desktopRows = Math.max(1, Math.min(4, Number.parseInt(sectionElement.dataset.ugcDesktopRows || '1', 10) || 1));
      const mobileRows = Math.max(1, Math.min(4, Number.parseInt(sectionElement.dataset.ugcMobileRows || '1', 10) || 1));
      const desktopTargets = collectTargets('desktop', 4);
      const mobileTargets = collectTargets('mobile', 4);

      if (!sourceItems.length) {
        desktopTargets.forEach((targets) => appendClones(targets, []));
        mobileTargets.forEach((targets) => appendClones(targets, []));
        return;
      }

      const desktopItemsByRow = distributeItems(sourceItems, desktopRows);
      const mobileItemsByRow = distributeItems(sourceItems, mobileRows);

      desktopTargets.forEach((targets, index) => {
        appendClones(targets, index < desktopRows ? desktopItemsByRow[index] : []);
      });

      mobileTargets.forEach((targets, index) => {
        appendClones(targets, index < mobileRows ? mobileItemsByRow[index] : []);
      });
    };

    const setupTrackInteraction = (track) => {
      if (!(track instanceof HTMLElement)) return;
      if (track.hasAttribute('data-ugc-interaction-bound')) return;

      let pointerId = null;
      let isPointerDown = false;
      let isDragging = false;
      let hasDragged = false;
      let startX = 0;
      let startOffset = 0;
      let cycleDistance = 0;

      const getOffset = () => {
        const value = track.style.getPropertyValue('--ugc-offset-x');
        const parsed = Number.parseFloat(value);
        return Number.isNaN(parsed) ? 0 : parsed;
      };

      const setOffset = (value) => {
        track.style.setProperty('--ugc-offset-x', `${value}px`);
      };

      const normalizeOffset = (value) => {
        if (cycleDistance <= 0) return value;

        let normalized = value % cycleDistance;
        if (normalized > 0) {
          normalized -= cycleDistance;
        }

        return normalized;
      };

      const updateCycleDistance = () => {
        const firstGroup = track.firstElementChild;
        if (!(firstGroup instanceof HTMLElement)) {
          cycleDistance = 0;
          return;
        }

        const computedStyles = getComputedStyle(track);
        const gap = Number.parseFloat(computedStyles.columnGap || computedStyles.gap || '0') || 0;
        cycleDistance = firstGroup.getBoundingClientRect().width + gap;

        setOffset(normalizeOffset(getOffset()));
      };

      const setPaused = (paused) => {
        track.style.animationPlayState = paused ? 'paused' : 'running';
      };

      const onPointerMove = (event) => {
        if (!isPointerDown || event.pointerId !== pointerId) return;

        const delta = event.clientX - startX;

        if (!isDragging && Math.abs(delta) > 4) {
          isDragging = true;
          hasDragged = true;
          track.classList.add('is-dragging');
          if (!track.hasPointerCapture(event.pointerId)) {
            track.setPointerCapture(event.pointerId);
          }
        }

        if (!isDragging) return;

        const nextOffset = normalizeOffset(startOffset + delta);
        setOffset(nextOffset);

        if (event.cancelable) {
          event.preventDefault();
        }
      };

      const onPointerEnd = (event) => {
        if (!isPointerDown || event.pointerId !== pointerId) return;

        isPointerDown = false;
        isDragging = false;
        track.classList.remove('is-dragging');

        if (track.matches(':hover')) {
          setPaused(true);
        } else {
          setPaused(false);
        }

        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }

        pointerId = null;
      };

      track.addEventListener('mouseenter', () => {
        if (!isDragging) {
          setPaused(true);
        }
      });

      track.addEventListener('mouseleave', () => {
        if (!isDragging) {
          setPaused(false);
        }
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;

        pointerId = event.pointerId;
        isPointerDown = true;
        isDragging = false;
        hasDragged = false;
        startX = event.clientX;
        updateCycleDistance();
        startOffset = normalizeOffset(getOffset());
        setOffset(startOffset);

        setPaused(true);
      });

      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerEnd);
      track.addEventListener('pointercancel', onPointerEnd);

      track.addEventListener(
        'click',
        (event) => {
          if (hasDragged) {
            event.preventDefault();
            event.stopPropagation();
            hasDragged = false;
          }
        },
        true
      );

      updateCycleDistance();
      window.addEventListener('resize', updateCycleDistance);
      track.setAttribute('data-ugc-interaction-bound', 'true');
    };

    const init = (root = document) => {
      root.querySelectorAll('.advanced-marquee').forEach((sectionElement) => {
        buildSection(sectionElement);
        sectionElement
          .querySelectorAll('.advanced-marquee__desktop-track, .advanced-marquee__mobile-track')
          .forEach((track) => {
            setupTrackInteraction(track);
          });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        init(event.target);
      }
    });

    document.addEventListener('shopify:block:select', () => init());
    document.addEventListener('shopify:block:deselect', () => init());
    document.addEventListener('shopify:section:reorder', () => init());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["button-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DRAG_THRESHOLD = 6;

    const getTriggers = (section) => Array.from(section.querySelectorAll('[data-button-slideshow-trigger]'));

    const getPanels = (section) => Array.from(section.querySelectorAll('[data-button-slideshow-panel]'));

    const getSlideshow = (section) => section.querySelector('[data-button-slideshow-component]');

    const getIndexFromTargetId = (section, targetId) => {
      const triggers = getTriggers(section);

      return triggers.findIndex((trigger) => trigger.getAttribute('data-target') === targetId);
    };

    const getActiveIndex = (section) => {
      const triggers = getTriggers(section);

      return triggers.findIndex((trigger) => trigger.getAttribute('aria-selected') === 'true');
    };

    const syncTriggerVisibility = (trigger) => {
      if (!(trigger instanceof HTMLElement)) {
        return;
      }

      trigger.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    };

    const setActiveIndex = (section, requestedIndex, options = {}) => {
      const triggers = getTriggers(section);
      const panels = getPanels(section);

      if (triggers.length === 0 || panels.length === 0) {
        return;
      }

      const nextIndex = Math.max(0, Math.min(requestedIndex, triggers.length - 1));
      const activeTrigger = triggers[nextIndex];

      if (!(activeTrigger instanceof HTMLElement)) {
        return;
      }

      triggers.forEach((trigger, index) => {
        const isActive = index === nextIndex;
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        trigger.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel, index) => {
        const isActive = index === nextIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (options.scrollTrigger) {
        syncTriggerVisibility(activeTrigger);
      }

      if (options.syncSlideshow) {
        const slideshow = getSlideshow(section);

        if (slideshow && typeof slideshow.select === 'function') {
          slideshow.select(nextIndex, undefined, { animate: options.animate !== false });
        }
      }

      if (options.focusTrigger) {
        activeTrigger.focus();
      }
    };

    const setActiveSlide = (section, targetId, options = {}) => {
      const targetIndex = getIndexFromTargetId(section, targetId);

      if (targetIndex === -1) {
        return;
      }

      setActiveIndex(section, targetIndex, options);
    };

    const moveFocus = (section, currentTrigger, direction) => {
      const triggers = getTriggers(section);
      const currentIndex = triggers.indexOf(currentTrigger);

      if (currentIndex === -1 || triggers.length === 0) {
        return;
      }

      const nextIndex = Math.max(0, Math.min(currentIndex + direction, triggers.length - 1));
      const nextTrigger = triggers[nextIndex];

      if (!nextTrigger || nextIndex === currentIndex) {
        return;
      }

      setActiveIndex(section, nextIndex, { focusTrigger: true, syncSlideshow: true });
    };

    const setupDragScroll = (section) => {
      const buttons = section.querySelector('.button-slideshow__buttons');

      if (!(buttons instanceof HTMLElement)) {
        return;
      }

      let startX = 0;
      let startScrollLeft = 0;
      let isPointerDown = false;
      let dragging = false;
      let suppressClick = false;

      const endDrag = () => {
        isPointerDown = false;
        dragging = false;
        buttons.classList.remove('is-dragging');
      };

      buttons.addEventListener('mousedown', (event) => {
        if (event.button !== 0) {
          return;
        }

        startX = event.clientX;
        startScrollLeft = buttons.scrollLeft;
        isPointerDown = true;
        dragging = false;
        suppressClick = false;
      });

      window.addEventListener('mousemove', (event) => {
        if (!isPointerDown) {
          return;
        }

        const deltaX = event.clientX - startX;

        if (!dragging && Math.abs(deltaX) > DRAG_THRESHOLD) {
          dragging = true;
          suppressClick = true;
          buttons.classList.add('is-dragging');
        }

        if (!dragging) {
          return;
        }

        event.preventDefault();
        buttons.scrollLeft = startScrollLeft - deltaX;
      });

      window.addEventListener('mouseup', () => {
        endDrag();
      });

      buttons.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        },
        true
      );
    };

    const setupSlideshowSync = (section) => {
      const slideshow = getSlideshow(section);

      if (!(slideshow instanceof HTMLElement)) {
        return;
      }

      slideshow.addEventListener('slideshow:select', (event) => {
        if (!event.detail || typeof event.detail.index !== 'number') {
          return;
        }

        setActiveIndex(section, event.detail.index, {
          animate: false,
          scrollTrigger: true,
        });
      });
    };

    const setupSection = (section) => {
      if (section.dataset.buttonSlideshowReady === 'true') {
        return;
      }

      section.dataset.buttonSlideshowReady = 'true';
      setupDragScroll(section);
      setupSlideshowSync(section);
      setActiveIndex(section, Math.max(getActiveIndex(section), 0), { animate: false });

      section.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-button-slideshow-trigger]');

        if (!trigger || !section.contains(trigger)) {
          return;
        }

        setActiveSlide(section, trigger.getAttribute('data-target'), {
          scrollTrigger: true,
          syncSlideshow: true,
        });
      });

      section.addEventListener('keydown', (event) => {
        const trigger = event.target.closest('[data-button-slideshow-trigger]');

        if (!trigger || !section.contains(trigger)) {
          return;
        }

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          moveFocus(section, trigger, 1);
        }

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          moveFocus(section, trigger, -1);
        }

        if (event.key === 'Home') {
          event.preventDefault();
          const firstTrigger = section.querySelector('[data-button-slideshow-trigger]');

          if (!firstTrigger) {
            return;
          }

          setActiveSlide(section, firstTrigger.getAttribute('data-target'), {
            focusTrigger: true,
            scrollTrigger: true,
            syncSlideshow: true,
          });
        }

        if (event.key === 'End') {
          event.preventDefault();
          const triggers = section.querySelectorAll('[data-button-slideshow-trigger]');
          const lastTrigger = triggers[triggers.length - 1];

          if (!lastTrigger) {
            return;
          }

          setActiveSlide(section, lastTrigger.getAttribute('data-target'), {
            focusTrigger: true,
            scrollTrigger: true,
            syncSlideshow: true,
          });
        }
      });
    };

    document.querySelectorAll('[data-button-slideshow]').forEach(setupSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centered-carousel"] && !Shopify.designMode) return;
  try {
    
  class CenteredCarouselComponent extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-centered-carousel-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-centered-carousel-dot]'));
      this.currentIndex = 0;
      this.pointerStart = null;
      this.pointerStartY = null;
      this.pointerId = null;
      this.pointerType = null;
      this.pointerAxis = null;
      this.touchIdentifier = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchAxis = null;
      this.directionLockThreshold = 6;
      this.dragDistance = 0;
      this.dragThreshold = 0;
      this.dragTriggered = false;
      this.dragTarget = null;
      this.dragFrame = null;
      this.pendingDragDistance = 0;
      this.settleTimer = null;
      this.suppressClickUntil = 0;
      this.abortController = new AbortController();

      const { signal } = this.abortController;
      this.addEventListener('click', this.handleClick, { signal });
      this.addEventListener('keydown', this.handleKeydown, { signal });
      this.addEventListener('pointerdown', this.handlePointerDown, { signal });
      this.addEventListener('pointermove', this.handlePointerMove, { signal });
      this.addEventListener('pointerup', this.handlePointerUp, { signal });
      this.addEventListener('pointercancel', this.handlePointerCancel, { signal });
      this.addEventListener('lostpointercapture', this.handleLostPointerCapture, { signal });
      this.addEventListener('touchstart', this.handleTouchStart, { signal, passive: true });
      this.addEventListener('touchmove', this.handleTouchMove, { signal, passive: false });
      this.addEventListener('touchend', this.handleTouchEnd, { signal, passive: true });
      this.addEventListener('touchcancel', this.handleTouchEnd, { signal, passive: true });
      this.addEventListener('dragstart', this.preventNativeDrag, { signal });
      document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });

      this.select(0, false);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      window.cancelAnimationFrame(this.dragFrame);
      window.clearTimeout(this.settleTimer);
      this.initialized = false;
    }

    handleClick = (event) => {
      if (Date.now() < this.suppressClickUntil) return;

      const dot = event.target.closest('[data-centered-carousel-dot]');
      if (dot && this.contains(dot)) {
        this.select(Number(dot.dataset.centeredCarouselDot));
        return;
      }

      const slide = event.target.closest('[data-centered-carousel-slide]');
      if (!slide || !this.contains(slide)) return;

      if (slide.dataset.position === 'previous') this.previous();
      if (slide.dataset.position === 'next') this.next();
    };

    handleKeydown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.previous();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.next();
      }
    };

    handlePointerDown = (event) => {
      if (!event.isPrimary) return;
      if (event.button !== 0) return;
      if (!event.target.closest('[data-centered-carousel-track]')) return;
      if (this.slides.length < 2) return;

      this.pointerStart = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerId = event.pointerId;
      this.pointerType = event.pointerType;
      this.pointerAxis = event.pointerType === 'touch' ? null : 'horizontal';

      if (this.pointerAxis === 'horizontal') {
        this.beginDrag(event.clientX);
        this.capturePointer(event.pointerId);
      }
    };

    capturePointer(pointerId) {
      if (this.hasPointerCapture(pointerId)) return;

      try {
        this.setPointerCapture(pointerId);
      } catch {}
    }

    beginDrag(clientX) {
      window.clearTimeout(this.settleTimer);
      this.pointerStart = clientX;
      this.dragDistance = 0;
      const slideWidth = this.slides[this.currentIndex]?.offsetWidth || this.clientWidth * 0.82;
      const thresholdRatio = window.matchMedia('(max-width: 749px)').matches ? 0.25 : 0.5;
      this.dragThreshold = slideWidth * thresholdRatio;
      const configuredPeek = Number.parseFloat(
        window.getComputedStyle(this).getPropertyValue('--centered-carousel-peek'),
      );
      this.peekOffset = Number.isFinite(configuredPeek) ? configuredPeek : 12;
      this.dragTriggered = false;
      this.clearDragPresentation();
      this.setAttribute('dragging', '');
    }

    handlePointerMove = (event) => {
      if (this.pointerStart === null || event.pointerId !== this.pointerId) return;

      const distanceX = event.clientX - this.pointerStart;

      if (this.pointerType === 'touch' && this.pointerAxis === null) {
        const distanceY = event.clientY - this.pointerStartY;
        if (Math.max(Math.abs(distanceX), Math.abs(distanceY)) < this.directionLockThreshold) return;

        this.pointerAxis = Math.abs(distanceX) > Math.abs(distanceY) ? 'horizontal' : 'vertical';
        if (this.pointerAxis === 'vertical') return;

        this.beginDrag(this.pointerStart);
      }

      if (this.pointerAxis !== 'horizontal') return;

      event.preventDefault();
      this.pendingDragDistance = distanceX;
      if (this.dragFrame !== null) return;
      this.dragFrame = window.requestAnimationFrame(() => {
        this.dragFrame = null;
        this.renderDrag(this.pendingDragDistance);
      });
    };

    renderDrag(distance) {
      const maximumDistance = this.dragThreshold;
      this.dragDistance = Math.max(-maximumDistance, Math.min(maximumDistance, distance));
      this.slides[this.currentIndex].style.setProperty('--centered-carousel-drag-x', `${this.dragDistance}px`);
      this.updateDragPresentation(distance);
    }

    preventNativeDrag = (event) => {
      event.preventDefault();
    };

    handlePointerUp = (event) => {
      if (this.pointerStart === null || event.pointerId !== this.pointerId) return;

      if (this.pointerAxis !== 'horizontal') {
        this.resetPointer(event);
        return;
      }

      this.finishDrag(event.clientX - this.pointerStart, event);
    };

    handlePointerCancel = (event) => {
      this.resetPointer(event);
    };

    handleLostPointerCapture = (event) => {
      if (event.target !== this) return;

      this.resetPointer(event);
    };

    handleTouchStart = (event) => {
      if (event.touches.length !== 1) {
        this.clearTouchDirection();
        return;
      }
      if (!event.target.closest('[data-centered-carousel-track]')) return;
      if (this.slides.length < 2) return;

      const touch = event.changedTouches[0];
      this.touchIdentifier = touch.identifier;
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      this.touchAxis = null;
    };

    handleTouchMove = (event) => {
      if (this.touchIdentifier === null || this.touchAxis === 'vertical') return;

      const touch = Array.from(event.touches).find((item) => item.identifier === this.touchIdentifier);
      if (!touch) return;

      if (this.touchAxis === null) {
        const distanceX = touch.clientX - this.touchStartX;
        const distanceY = touch.clientY - this.touchStartY;
        if (Math.max(Math.abs(distanceX), Math.abs(distanceY)) < this.directionLockThreshold) return;

        this.touchAxis = Math.abs(distanceX) > Math.abs(distanceY) ? 'horizontal' : 'vertical';
      }

      if (this.touchAxis === 'horizontal' && event.cancelable) event.preventDefault();
    };

    handleTouchEnd = (event) => {
      if (this.touchIdentifier === null) return;

      const endedTouch = Array.from(event.changedTouches).some((touch) => touch.identifier === this.touchIdentifier);
      if (endedTouch || event.touches.length === 0) this.clearTouchDirection();
    };

    clearTouchDirection() {
      this.touchIdentifier = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchAxis = null;
    }

    finishDrag(distance, event) {
      window.cancelAnimationFrame(this.dragFrame);
      this.dragFrame = null;
      this.renderDrag(distance);

      if (Math.abs(distance) >= this.dragThreshold) {
        this.dragTriggered = true;
        this.suppressClickUntil = Number.POSITIVE_INFINITY;
        this.setAttribute('switching', '');
        this.getBoundingClientRect();
        this.style.removeProperty('--centered-carousel-drag-x');

        if (distance > 0) {
          this.previous();
        } else {
          this.next();
        }

        this.clearDragStyles();
        this.resetPointer(event, true);
        this.settleTimer = window.setTimeout(() => this.clearDragPresentation(), 360);
        return;
      }

      this.resetPointer(event);
    }

    resetPointer = (event, preservePresentation = false) => {
      if (this.pointerStart === null && this.pointerId === null) return;
      if (event?.pointerId != null && this.pointerId != null && event.pointerId !== this.pointerId) return;

      const releasedPointerId = this.pointerId;
      const suppressClick = this.dragTriggered;
      window.cancelAnimationFrame(this.dragFrame);
      this.dragFrame = null;

      this.pointerStart = null;
      this.pointerStartY = null;
      this.pointerId = null;
      this.pointerType = null;
      this.pointerAxis = null;
      this.dragDistance = 0;
      this.dragThreshold = 0;
      this.dragTriggered = false;
      this.removeAttribute('dragging');
      this.removeAttribute('switching');
      this.style.removeProperty('--centered-carousel-drag-x');

      if (!preservePresentation) this.clearDragPresentation();
      if (suppressClick) this.suppressClickUntil = Date.now() + 300;

      if (releasedPointerId != null && this.hasPointerCapture(releasedPointerId)) {
        this.releasePointerCapture(releasedPointerId);
      }
    };

    updateDragPresentation(distance) {
      if (!distance || !this.dragThreshold) {
        this.clearDragPresentation();
        return;
      }

      const progress = Math.min(Math.abs(distance) / this.dragThreshold, 1);
      const easedProgress = progress * progress * (3 - 2 * progress);
      const direction = distance > 0 ? -1 : 1;
      const targetIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length;
      const activeSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[targetIndex];

      if (this.dragTarget && this.dragTarget !== targetSlide) {
        this.clearSlideDragPresentation(this.dragTarget);
      }

      if (this.dragTarget !== targetSlide) {
        this.dragTarget = targetSlide;
        this.setAttribute('drag-active', '');
        activeSlide.dataset.dragOutgoing = '';
        targetSlide.dataset.dragTarget = '';
      }

      const activeScale = 1 - 0.12 * easedProgress;
      activeSlide.style.setProperty('--centered-carousel-slide-scale', String(activeScale));

      const targetScale = 0.88 + 0.12 * easedProgress;
      const targetTranslate = direction * this.peekOffset * (1 - easedProgress);
      targetSlide.style.setProperty('--centered-carousel-slide-scale', String(targetScale));
      targetSlide.style.setProperty('--centered-carousel-side-translate', `${targetTranslate}%`);
    }

    clearSlideDragPresentation(slide) {
      if (!slide) return;

      delete slide.dataset.dragTarget;
      delete slide.dataset.dragOutgoing;
      this.clearSlideDragStyles(slide);
    }

    clearSlideDragStyles(slide) {
      if (!slide) return;

      slide.style.removeProperty('--centered-carousel-slide-scale');
      slide.style.removeProperty('--centered-carousel-drag-x');
      slide.style.removeProperty('--centered-carousel-side-translate');
    }

    clearDragStyles() {
      this.slides?.forEach((slide) => this.clearSlideDragStyles(slide));
    }

    clearDragPresentation() {
      this.slides?.forEach((slide) => this.clearSlideDragPresentation(slide));
      this.dragTarget = null;
      this.removeAttribute('drag-active');
    }

    handleBlockSelect = (event) => {
      const slide = event.target.closest('[data-centered-carousel-slide]');
      if (!slide || !this.contains(slide)) return;

      const index = this.slides.indexOf(slide);
      if (index >= 0) this.select(index, false);
    };

    previous() {
      this.select(this.currentIndex - 1);
    }

    next() {
      this.select(this.currentIndex + 1);
    }

    select(index, focusDot = false) {
      const length = this.slides.length;
      if (!length) return;

      this.currentIndex = (index + length) % length;
      const previousIndex = (this.currentIndex - 1 + length) % length;
      const nextIndex = (this.currentIndex + 1) % length;

      this.slides.forEach((slide, slideIndex) => {
        let position = 'hidden';
        if (slideIndex === previousIndex) position = 'previous';
        if (slideIndex === nextIndex) position = 'next';
        if (slideIndex === this.currentIndex) position = 'active';

        slide.dataset.position = position;
        slide.setAttribute('aria-hidden', String(position !== 'active'));

        const externalTemplate = slide.querySelector('[data-centered-carousel-external-video]');
        if (externalTemplate) {
          const iframe = slide.querySelector('iframe');
          if (position === 'active' && !iframe) {
            externalTemplate.after(externalTemplate.content.cloneNode(true));
          } else if (position !== 'active') {
            iframe?.remove();
          }
        }

        const video = slide.querySelector('video');
        if (!video) return;

        if (position === 'active') {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === this.currentIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (focusDot) this.dots[this.currentIndex]?.focus();
    }
  }

  if (!customElements.get('centered-carousel-component')) {
    customElements.define('centered-carousel-component', CenteredCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["competitor-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.competitor-comparison';
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    const getCenteredCard = (grid) =>
      grid.querySelector('.competitor-comparison-card.focus') || grid.children[1] || grid.children[0];

    const syncSideSpace = (section) => {
      const shell = section.querySelector('.competitor-comparison__shell');
      const grid = section.querySelector('.competitor-comparison__grid');
      const firstCard = grid ? grid.querySelector('.competitor-comparison-card') : null;

      if (!shell || !grid || !firstCard || !mobileQuery.matches) {
        section.style.removeProperty('--competitor-comparison-side-space');
        return;
      }

      const sideSpace = Math.max((shell.clientWidth - firstCard.offsetWidth) / 2, 0);

      section.style.setProperty('--competitor-comparison-side-space', `${sideSpace}px`);
    };

    const centerFocusedCard = (section) => {
      const shell = section.querySelector('.competitor-comparison__shell');
      const grid = section.querySelector('.competitor-comparison__grid');
      const card = grid ? getCenteredCard(grid) : null;

      if (!shell || !card || !mobileQuery.matches) {
        return;
      }

      const scrollLeft = card.offsetLeft - (shell.clientWidth - card.offsetWidth) / 2;
      const maxScrollLeft = Math.max(shell.scrollWidth - shell.clientWidth, 0);

      shell.scrollLeft = Math.min(Math.max(0, scrollLeft), maxScrollLeft);
    };

    const initSection = (section) => {
      syncSideSpace(section);
      centerFocusedCard(section);
    };

    const init = (root = document) => {
      root.querySelectorAll(sectionSelector).forEach((section) => {
        initSection(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });

    mobileQuery.addEventListener?.('change', () => init());
    window.addEventListener('resize', () => init());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__customHeaderSearchDrawerInit) return;
    window.__customHeaderSearchDrawerInit = true;

    const getSearchDrawer = () => document.querySelector('.search-drawer.header-drawer-shell--search');
    const getCartDrawer = () => document.querySelector('.cart-drawer-shell.header-drawer-shell--cart');
    const syncScrollLock = () => {
      const hasOpenSearchDrawer = document.querySelector('.search-drawer.header-drawer-shell--search.is-open');
      const hasOpenCartDrawer = document.querySelector('.cart-drawer-shell.header-drawer-shell--cart.is-open');
      const hasOpenCustomHeaderDrawer = document.querySelector('.custom-header__drawer.is-open');
      const shouldLockScroll = Boolean(hasOpenSearchDrawer || hasOpenCartDrawer || hasOpenCustomHeaderDrawer);
      document.documentElement.toggleAttribute('scroll-lock', shouldLockScroll);
    };

    const openSearchDrawer = () => {
      const searchDrawer = getSearchDrawer();
      if (!searchDrawer) return;

      searchDrawer.classList.add('is-open');
      searchDrawer.setAttribute('aria-hidden', 'false');
      syncScrollLock();
    };

    const openCartDrawer = () => {
      const cartDrawer = getCartDrawer();
      if (!cartDrawer) return;

      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      syncScrollLock();
    };

    const closeSearchDrawer = () => {
      const searchDrawer = getSearchDrawer();
      if (!searchDrawer) return;

      searchDrawer.classList.remove('is-open');
      searchDrawer.setAttribute('aria-hidden', 'true');
      syncScrollLock();
    };

    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-search-drawer-open]');
      if (openTrigger) {
        openSearchDrawer();
        return;
      }

      const openCartTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openCartTrigger) {
        openCartDrawer();
        return;
      }

      const mask = event.target.closest('.search-drawer.header-drawer-shell--search .header-drawer-shell__mask');
      if (mask) {
        closeSearchDrawer();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeSearchDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-information"] && !Shopify.designMode) return;
  try {
    
  const initializedGloboForms = new WeakSet();
  let globoRenderQueue = Promise.resolve();

  class FeaturedProductInformation extends HTMLElement {
    #abortController;

    connectedCallback() {
      this.#abortController = new AbortController();
      document.addEventListener('gpoRenderCompleted', this.#initializeGlobo, {
        signal: this.#abortController.signal,
      });
      customElements.whenDefined('product-form-component').then(this.#initializeGlobo);
    }

    disconnectedCallback() {
      this.#abortController.abort();
    }

    #initializeGlobo = () => {
      if (!this.isConnected) return;

      const globo = window.GPOConfigs;
      if (!globo?.translations || typeof globo.loadMainScripts !== 'function') return;

      const form = this.querySelector('form[data-type="add-to-cart-form"]');
      const productData = this.querySelector('[data-featured-product]');
      if (!form || !productData || !form.querySelector('.gpo-product-variants')) return;
      if (initializedGloboForms.has(form) || form.querySelector('.gpo-app')) return;

      const { product, collections } = JSON.parse(productData.textContent);
      product.collections = collections;
      initializedGloboForms.add(form);

      globoRenderQueue = globoRenderQueue
        .then(async () => {
          if (!this.isConnected || !form.isConnected) {
            initializedGloboForms.delete(form);
            return;
          }

          await globo.loadMainScripts(product, globo.customer, form);
        })
        .catch((error) => {
          initializedGloboForms.delete(form);
          console.error('Unable to initialize Globo featured product options.', error);
        });
    };
  }

  if (!customElements.get('featured-product-information')) {
    customElements.define('featured-product-information', FeaturedProductInformation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["make-model-year-filter"] && !Shopify.designMode) return;
  try {
    
  const vehicleFilterRequests = new Map();

  const loadVehicleFilterOptions = (url) => {
    if (!vehicleFilterRequests.has(url)) {
      console.log('[Vehicle filter] Request started', { url });

      const request = fetch(url, {
        headers: {
          Accept: 'text/html',
        },
      })
        .then((response) => {
          console.log('[Vehicle filter] Response received', {
            url,
            status: response.status,
            ok: response.ok,
          });

          if (!response.ok) {
            throw new Error(`Unable to load vehicle filters: ${response.status}`);
          }

          return response.text();
        })
        .then((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const dataElement = documentFragment.querySelector('[data-vehicle-filter-options]');

          if (!dataElement) {
            throw new Error('Vehicle filter data was not found');
          }

          const options = JSON.parse(dataElement.textContent);

          console.log('[Vehicle filter] Options parsed', {
            url,
            options,
          });

          return options;
        })
        .catch((error) => {
          console.error('[Vehicle filter] Request failed', {
            url,
            error,
          });
          vehicleFilterRequests.delete(url);
          throw error;
        });

      vehicleFilterRequests.set(url, request);
    } else {
      console.log('[Vehicle filter] Using cached request', { url });
    }

    return vehicleFilterRequests.get(url);
  };

  const populateVehicleFilterSelect = (select, values, sortDescending = false) => {
    select.options.length = 1;

    const options = [...values];

    options.sort((first, second) => {
      const result = first.label.localeCompare(second.label, undefined, {
        numeric: true,
        sensitivity: 'base',
      });

      return sortDescending ? result * -1 : result;
    });

    options.forEach((item) => {
      const option = document.createElement('option');
      option.value = item.value;
      option.textContent = item.label;
      select.append(option);
    });

    select.disabled = options.length === 0;
  };

  const resetVehicleFilterSelect = (select) => {
    select.options.length = 1;
    select.value = '';
    select.disabled = true;
  };

  const buildVehicleFilterOptionsUrl = (baseUrl, selections = {}) => {
    const url = new URL(baseUrl, window.location.origin);

    Object.entries(selections).forEach(([name, value]) => {
      if (value) {
        url.searchParams.set(name, value);
      }
    });

    return url.toString();
  };

  const initializeVehicleFilter = async (element) => {
    if (element.dataset.initialized === 'true') {
      return;
    }

    element.dataset.initialized = 'true';

    const makeSelect = element.querySelector('[data-vehicle-filter-select="make"]');
    const modelSelect = element.querySelector('[data-vehicle-filter-select="model"]');
    const yearSelect = element.querySelector('[data-vehicle-filter-select="year"]');
    const submitButton = element.querySelector('[data-vehicle-filter-submit]');
    const form = element.querySelector('form');
    let requestSequence = 0;

    if (!makeSelect || !modelSelect || !yearSelect || !submitButton || !form) {
      return;
    }

    const updateSubmitState = () => {
      submitButton.disabled = !makeSelect.value;
    };

    makeSelect.addEventListener('change', async () => {
      const currentRequest = ++requestSequence;
      const selectedMake = makeSelect.value;

      resetVehicleFilterSelect(modelSelect);
      resetVehicleFilterSelect(yearSelect);
      updateSubmitState();

      if (!selectedMake) {
        return;
      }

      try {
        const url = buildVehicleFilterOptionsUrl(element.dataset.optionsUrl, {
          'filter.p.m.custom.make': selectedMake,
        });
        const options = await loadVehicleFilterOptions(url);

        if (currentRequest !== requestSequence || makeSelect.value !== selectedMake) {
          return;
        }

        populateVehicleFilterSelect(modelSelect, options.model);
      } catch (error) {
        if (currentRequest !== requestSequence) {
          return;
        }
      }
    });

    modelSelect.addEventListener('change', async () => {
      const currentRequest = ++requestSequence;
      const selectedMake = makeSelect.value;
      const selectedModel = modelSelect.value;

      resetVehicleFilterSelect(yearSelect);
      updateSubmitState();

      if (!selectedMake || !selectedModel) {
        return;
      }

      try {
        const url = buildVehicleFilterOptionsUrl(element.dataset.optionsUrl, {
          'filter.p.m.custom.make': selectedMake,
          'filter.p.m.custom.model': selectedModel,
        });
        const options = await loadVehicleFilterOptions(url);

        if (
          currentRequest !== requestSequence ||
          makeSelect.value !== selectedMake ||
          modelSelect.value !== selectedModel
        ) {
          return;
        }

        populateVehicleFilterSelect(yearSelect, options.year, true);
      } catch (error) {
        if (currentRequest !== requestSequence) {
          return;
        }
      }
    });

    yearSelect.addEventListener('change', updateSubmitState);

    form.addEventListener('submit', () => {
      console.log('[Vehicle filter] Search submitted', {
        action: form.action,
        values: Object.fromEntries(new FormData(form).entries()),
      });
    });

    try {
      const options = await loadVehicleFilterOptions(element.dataset.optionsUrl);

      populateVehicleFilterSelect(makeSelect, options.make);
      resetVehicleFilterSelect(modelSelect);
      resetVehicleFilterSelect(yearSelect);
      updateSubmitState();
    } catch {}
  };

  const initializeVehicleFilters = (root = document) => {
    root.querySelectorAll('make-model-year-filter').forEach(initializeVehicleFilter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeVehicleFilters(), { once: true });
  } else {
    initializeVehicleFilters();
  }

  document.addEventListener('shopify:section:load', (event) => initializeVehicleFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-with-icons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('multicolumn-icons')) {
    customElements.define(
      'multicolumn-icons',
      class extends HTMLElement {
        connectedCallback() {
          const slideshow = this.querySelector('.multicolumn-icons-slider');
          if (!slideshow) return;
          const scroller = slideshow.querySelector('slideshow-slides');
          const mobile = matchMedia('(max-width: 749px)');
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          const update = () => {
            slideshow.setAttribute('disabled', String(!mobile.matches));
            scroller.tabIndex = mobile.matches ? 0 : -1;
            if (!mobile.matches) scroller.scrollLeft = 0;
          };
          mobile.addEventListener('change', update, { signal });
          scroller.addEventListener(
            'focusin',
            (event) => {
              if (!mobile.matches) return;
              const column = event.target.closest('.multicolumn-icon-column');
              const index = Array.from(scroller.children).indexOf(column);
              if (index >= 0) slideshow.select?.(index, undefined, { animate: false });
            },
            { signal },
          );
          update();
        }
        disconnectedCallback() {
          this.abortController?.abort();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-scrolling"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopMediaQuery = window.matchMedia('(min-width: 750px)');
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const getTravelOffset = (section, side, progress) => {
      const layer = section.querySelector(`[data-parallax-scrolling-layer='${side}']`);

      if (!layer) {
        return 0;
      }

      const rail = layer.querySelector('.parallax-scrolling-images');

      if (!rail) {
        return 0;
      }

      const isDesktop = desktopMediaQuery.matches;
      const maxTravel = isDesktop
        ? Math.max(0, rail.scrollHeight - layer.clientHeight)
        : Math.max(0, rail.scrollWidth - layer.clientWidth);

      if (side == 'right') {
        return maxTravel * progress;
      }

      return maxTravel * progress * -1;
    };

    const updateSection = (section) => {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom <= 0 || rect.top >= viewportHeight) {
        return;
      }

      const progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
      const leftOffset = getTravelOffset(section, 'left', progress);
      const rightOffset = getTravelOffset(section, 'right', progress);

      section.style.setProperty('--parallax-scrolling-rail-offset-left', `${leftOffset}px`);
      section.style.setProperty('--parallax-scrolling-rail-offset-right', `${rightOffset}px`);
    };

    const setupSection = (section) => {
      if (section.dataset.parallaxScrollingReady === 'true') {
        return;
      }

      section.dataset.parallaxScrollingReady = 'true';

      let ticking = false;

      const requestTick = () => {
        if (ticking) {
          return;
        }

        ticking = true;

        window.requestAnimationFrame(() => {
          updateSection(section);
          ticking = false;
        });
      };

      requestTick();
      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', requestTick);

      if (typeof desktopMediaQuery.addEventListener === 'function') {
        desktopMediaQuery.addEventListener('change', requestTick);
      } else if (typeof desktopMediaQuery.addListener === 'function') {
        desktopMediaQuery.addListener(requestTick);
      }
    };

    document.querySelectorAll('[data-parallax-scrolling-section]').forEach(setupSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["segmented-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncTabLabels = (root) => {
      const panels = Array.from(root.querySelectorAll('[data-segmented-faq-panel]'));

      panels.forEach((panel) => {
        const tabId = panel.getAttribute('aria-labelledby');
        if (!tabId) return;

        const tab = root.querySelector(`#${CSS.escape(tabId)}`);
        if (!(tab instanceof HTMLButtonElement)) return;

        const heading = panel.dataset.segmentedFaqHeading;
        if (heading) {
          tab.textContent = heading;
        }
      });
    };

    const updateTabs = (root, nextTab) => {
      const tabs = Array.from(root.querySelectorAll('[data-segmented-faq-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-segmented-faq-panel]'));

      tabs.forEach((tab) => {
        const isActive = tab === nextTab;
        tab.classList.toggle('segmented-faq-tab-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const isActive = panel.id === nextTab.getAttribute('aria-controls');
        panel.toggleAttribute('hidden', !isActive);
      });
    };

    const moveFocus = (tabs, currentTab, direction) => {
      const currentIndex = tabs.indexOf(currentTab);
      if (currentIndex < 0) return;

      const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
      tabs[nextIndex].focus();
    };

    const bindSection = (root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.hasAttribute('data-segmented-faq-bound')) return;

      const tabs = Array.from(root.querySelectorAll('[data-segmented-faq-tab]'));
      if (!tabs.length) return;

      syncTabLabels(root);

      root.addEventListener('click', (event) => {
        const tab = event.target instanceof Element ? event.target.closest('[data-segmented-faq-tab]') : null;
        if (!(tab instanceof HTMLButtonElement)) return;

        updateTabs(root, tab);
      });

      root.addEventListener('keydown', (event) => {
        const tab = event.target instanceof Element ? event.target.closest('[data-segmented-faq-tab]') : null;
        if (!(tab instanceof HTMLButtonElement)) return;

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveFocus(tabs, tab, 1);
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveFocus(tabs, tab, -1);
        }

        if (event.key === 'Home') {
          event.preventDefault();
          tabs[0].focus();
        }

        if (event.key === 'End') {
          event.preventDefault();
          tabs[tabs.length - 1].focus();
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          updateTabs(root, tab);
        }
      });

      const panels = root.querySelector('.segmented-faq-panels');
      if (panels instanceof HTMLElement) {
        const observer = new MutationObserver(() => syncTabLabels(root));
        observer.observe(panels, {
          attributes: true,
          attributeFilter: ['data-segmented-faq-heading'],
          childList: true,
          subtree: true,
        });
      }

      root.setAttribute('data-segmented-faq-bound', 'true');
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-segmented-faq]').forEach(bindSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        init(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const transitionDuration = 420;
    const textFadeDuration = 180;

    const sanitizeString = (value, fallback = '') => {
      if (typeof value !== 'string') return fallback;
      const trimmed = value.trim();
      return trimmed ? trimmed : fallback;
    };

    const parseReviews = (root) => {
      if (!(root instanceof HTMLElement)) return [];

      const sourceItems = Array.from(root.querySelectorAll('.ugc-reviews__source-item'));
      return sourceItems.map((item, index) => {
        const contentNode = item.querySelector('[data-review-content]');
        return {
          id: sanitizeString(item.dataset.reviewId, `review-${index + 1}`),
          rating: item.dataset.reviewRating,
          author: sanitizeString(item.dataset.reviewAuthor, 'Customer'),
          content: contentNode instanceof HTMLElement ? contentNode.innerHTML : '',
        };
      });
    };

    const normalizeRating = (value) => {
      const numeric = Number.parseFloat(value);
      if (Number.isNaN(numeric)) return 5;
      return Math.max(1, Math.min(5, numeric));
    };

    window.ugcReviews = () => ({
      reviews: [],
      currentIndex: 0,
      mediaOrderIndex: 0,
      mediaRoleIndex: 0,
      total: 0,
      direction: 'next',
      textVisible: true,
      textPhase: 'in',
      isAnimating: false,
      textTimer: null,
      mediaTimer: null,
      swipePointerId: null,
      swipeStartX: 0,
      swipeStartY: 0,
      swipeCurrentX: 0,
      swipeCurrentY: 0,
      swipeTracking: false,

      init() {
        const root = this.$el instanceof HTMLElement ? this.$el : null;

        this.reviews = parseReviews(root).map((review, index) => ({
          id: sanitizeString(review.id, `review-${index + 1}`),
          rating: normalizeRating(review.rating),
          author: sanitizeString(review.author, 'Customer'),
          content: sanitizeString(review.content, '<p></p>'),
        }));
        this.total = this.reviews.length;
        this.mediaOrderIndex = this.currentIndex;
        this.mediaRoleIndex = this.currentIndex;
        this.hydrateVisibleMedia();
      },

      isMobileViewport() {
        return window.matchMedia('(max-width: 749px)').matches;
      },

      get canNavigate() {
        return this.total > 1 && !this.isAnimating;
      },

      get canGoPrev() {
        return this.canNavigate && this.currentIndex > 0;
      },

      get canGoNext() {
        return this.canNavigate && this.currentIndex < this.total - 1;
      },

      get activeReview() {
        if (!this.total) return null;
        return this.reviews[this.currentIndex];
      },

      loopIndexFrom(baseIndex, offset) {
        if (!this.total) return 0;
        const raw = baseIndex + offset;
        return ((raw % this.total) + this.total) % this.total;
      },

      loopIndex(offset) {
        return this.loopIndexFrom(this.currentIndex, offset);
      },

      mediaRole(index) {
        if (!this.total) return 'hidden';
        const distance = index - this.mediaRoleIndex;
        if (distance === 0) return 'primary';
        if (distance === 1) return 'secondary';
        if (distance === 2) return 'tertiary';
        return 'hidden';
      },

      mediaOrder(index) {
        if (!this.total) return index;
        return index - this.mediaOrderIndex;
      },

      hydrateMediaImage(index) {
        if (!this.$el || index < 0 || index >= this.total) return;

        const mediaItem = this.$el.querySelector(`[data-ugc-review-media-index="${index}"]`);
        if (!(mediaItem instanceof HTMLElement)) return;

        const image = mediaItem.querySelector('.ugc-reviews__image[data-ugc-lazy-image]');
        if (!(image instanceof HTMLImageElement)) return;

        if (image.dataset.srcset) {
          image.srcset = image.dataset.srcset;
        }

        if (image.dataset.src) {
          image.src = image.dataset.src;
        }

        image.removeAttribute('data-ugc-lazy-image');
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
      },

      hydrateVisibleMedia(baseIndex = this.mediaRoleIndex) {
        this.hydrateMediaImage(baseIndex);
        this.hydrateMediaImage(baseIndex + 1);
        this.hydrateMediaImage(baseIndex + 2);
      },

      reviewByIndex(index) {
        if (!this.total || index < 0) return null;
        return this.reviews[index] || null;
      },

      ratingPercent(review) {
        if (!review) return 0;
        return (review.rating / 5) * 100;
      },

      ratingValue(review) {
        if (!review) return '';
        return Number(review.rating).toFixed(1);
      },

      ratingLabel(review) {
        if (!review) return '';
        return `${this.ratingValue(review)} out of 5 stars`;
      },

      next() {
        if (!this.canGoNext) return;
        this.rotate('next');
      },

      prev() {
        if (!this.canGoPrev) return;
        this.rotate('prev');
      },

      swipeStart(event) {
        if (!this.isMobileViewport()) return;
        if (!this.canNavigate) return;
        if (!(event instanceof PointerEvent)) return;
        if (event.pointerType === 'mouse') return;

        this.swipePointerId = event.pointerId;
        this.swipeStartX = event.clientX;
        this.swipeStartY = event.clientY;
        this.swipeCurrentX = event.clientX;
        this.swipeCurrentY = event.clientY;
        this.swipeTracking = true;
      },

      swipeMove(event) {
        if (!this.swipeTracking) return;
        if (!(event instanceof PointerEvent)) return;
        if (event.pointerId !== this.swipePointerId) return;

        this.swipeCurrentX = event.clientX;
        this.swipeCurrentY = event.clientY;
      },

      swipeEnd(event) {
        if (!this.swipeTracking) return;
        if (!(event instanceof PointerEvent)) {
          this.swipeReset();
          return;
        }
        if (event.pointerId !== this.swipePointerId) return;

        this.swipeCurrentX = event.clientX;
        this.swipeCurrentY = event.clientY;

        const deltaX = this.swipeCurrentX - this.swipeStartX;
        const deltaY = this.swipeCurrentY - this.swipeStartY;
        const horizontalDistance = Math.abs(deltaX);
        const verticalDistance = Math.abs(deltaY);
        const swipeThreshold = 40;

        if (horizontalDistance >= swipeThreshold && horizontalDistance > verticalDistance) {
          if (deltaX < 0) {
            this.next();
          } else {
            this.prev();
          }
        }

        this.swipeReset();
      },

      swipeReset() {
        this.swipePointerId = null;
        this.swipeTracking = false;
      },

      rotate(direction) {
        if (!this.canNavigate) return;

        this.direction = direction;
        this.isAnimating = true;

        window.clearTimeout(this.textTimer);
        window.clearTimeout(this.mediaTimer);

        const fromIndex = this.currentIndex;
        const step = direction === 'next' ? 1 : -1;
        const nextIndex = Math.max(0, Math.min(this.total - 1, fromIndex + step));

        if (nextIndex === fromIndex) {
          this.isAnimating = false;
          return;
        }

        this.hydrateVisibleMedia(nextIndex);

        this.textPhase = 'out';
        this.textVisible = false;

        if (direction === 'next') {
          this.mediaOrderIndex = fromIndex;
          window.requestAnimationFrame(() => {
            this.mediaRoleIndex = nextIndex;
          });
        } else {
          this.mediaOrderIndex = nextIndex;
          window.requestAnimationFrame(() => {
            this.mediaRoleIndex = nextIndex;
          });
        }

        this.textTimer = window.setTimeout(() => {
          this.currentIndex = nextIndex;
          this.textPhase = 'in';
          this.textVisible = false;
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              this.textVisible = true;
            });
          });
        }, textFadeDuration);

        this.mediaTimer = window.setTimeout(() => {
          this.isAnimating = false;
        }, transitionDuration);
      },
    });

    const ensureHydrated = (root = document) => {
      if (!window.Alpine || typeof window.Alpine.initTree !== 'function') return;
      if (!(root instanceof Document) && !(root instanceof HTMLElement)) return;

      root.querySelectorAll('.ugc-reviews__inner').forEach((element) => {
        if (!(element instanceof HTMLElement)) return;

        const state = element._x_dataStack && element._x_dataStack[0];
        const isBrokenState = state && typeof state.init !== 'function';

        if (isBrokenState && typeof window.Alpine.destroyTree === 'function') {
          window.Alpine.destroyTree(element);
          delete element._x_dataStack;
        }

        if (!element._x_dataStack) {
          window.Alpine.initTree(element);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          ensureHydrated(document);
        },
        { once: true }
      );
    } else {
      ensureHydrated(document);
    }

    document.addEventListener('alpine:initialized', () => {
      ensureHydrated(document);
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        ensureHydrated(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
